import * as React from 'react';
import classNames from 'classnames/bind';
import styles from './applyStepTitle.module.scss';

const cx = classNames.bind(styles);

const ApplyStepTitle = () => {
  return (
    <div className={cx('textArea')}>
      <strong className={cx('titleText')}>
        응시 과정별
        <br />
        결과를 확인해보세요.
      </strong>
      <p className={cx('subTitleText')}>
        각 응시과정을 누르면 세부적으로
        <br />
        보완이 필요한 부분을 알 수 있어요.
      </p>
    </div>
  );
};

export default ApplyStepTitle;
